import { coreUsersCurrentGetAsyncSlice } from './get';
import { CoreUsersCurrentName } from './name';
import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { User } from '@types';

export const updateCurrentUserSyncSlice = createUpdateSyncSlice<typeof CoreUsersCurrentName, User, Partial<User>>({
	name: CoreUsersCurrentName,
	state: coreUsersCurrentGetAsyncSlice.asyncState,
	transform: (action, state) => ({
		...state,
		...action
	} as User)
});
